module.exports = __webpack_public_path__ + "static/img/76073B_2_3_4_5_R_20180611_fit.6f11a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76073B_2_3_4_5_R_20180611_fit.png
// module id = 2s1N
// module chunks = 0